import { render } from "./ActionButtons.vue?vue&type=template&id=5ace9e6b"
import script from "./ActionButtons.vue?vue&type=script&lang=js"
export * from "./ActionButtons.vue?vue&type=script&lang=js"

import "./ActionButtons.vue?vue&type=style&index=0&id=5ace9e6b&lang=scss"
script.render = render

export default script